import {
  BankSchool,
  BankService,
  BankViewerExamsDto,
  BankViewerIntentDto,
  BankViewerSearchResultDto,
  BankViewerStatusDto,
  BankViewerTemplateDto,
  BankViewerUnitDto,
} from "@generated/admin";
import { ApiError } from "@generated/admin/core/ApiError";
import { useMutation, useQuery } from "@tanstack/react-query";

const KEY = ["admin", "bank"];

/** 이 환경에 문제은행이 있는지 — 로컬·스테이징만 있음. 사이드바 메뉴를 보일지 정한다 */
export const useBankStatus = (enabled: boolean) => {
  return useQuery<BankViewerStatusDto, ApiError>({
    queryKey: [...KEY, "status"],
    queryFn: () => BankService.bankStatus(),
    enabled,
    staleTime: Infinity,
  });
};

export const useBankExams = () => {
  return useQuery<BankViewerExamsDto, ApiError>({
    queryKey: [...KEY, "exams"],
    queryFn: () => BankService.bankExams(),
  });
};

/** 단원 하나의 소단원 목록 — school 을 주면 그 학교급 소단원만 */
export const useBankUnit = (key: string | null, school?: BankSchool) => {
  return useQuery<BankViewerUnitDto, ApiError>({
    queryKey: [...KEY, "unit", key, school ?? null],
    queryFn: () => BankService.bankUnit({ key: key as string, school }),
    enabled: !!key,
  });
};

export const useBankIntent = (key: string | null) => {
  return useQuery<BankViewerIntentDto, ApiError>({
    queryKey: [...KEY, "intent", key],
    queryFn: () => BankService.bankIntent({ key: key as string }),
    enabled: !!key,
  });
};

export const useBankTemplate = (key: string | null) => {
  return useQuery<BankViewerTemplateDto, ApiError>({
    queryKey: [...KEY, "template", key],
    queryFn: () => BankService.bankTemplate({ key: key as string }),
    enabled: !!key,
  });
};

/** key 로 찾기 — 문제틀 key·문항 key(틀@seed@버전)·문항 id */
export const useBankSearch = () => {
  return useMutation<BankViewerSearchResultDto, ApiError, string>({
    mutationFn: (q) => BankService.bankSearch({ q }),
  });
};
